/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: BaseEnv.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/Badge.ts;
 * Description: Copia di presenze ma associate a persone e con la gestione dei record degli accessi;
 * Author: giovannibattistadellaporta;
 * Created at: 20/03/24, 11:28;
 * Updated at: 20/03/24, 11:28;
 *
 *
 */

import { OggettoConfig } from "src/app/shared/_services/dynamic-crud.service";
import { Badge } from "../Tasks/Badge";
import { EMPTY } from "rxjs";

export var  BadgeEnv = () => {

    var OBJ: OggettoConfig = {
        Id: "badge",
        Filters: [
            { nome: "Dipendente", oggetti: ["nome"], modificabile: true, inputType: 'text', class: 'col-lg-6', OnChange: 'Refresh',},
            { nome: "Anno", oggetti:["anno"], modificabile: true, inputType: 'number', class: 'col-lg-1', OnChange: 'Refresh',},
            {
                modificabile: true,
                nome: 'Mese',
                oggetti: ['mese'],
                internalOutput: 'filtro',
                OutputField: 'mese',
                inputType: 'singleDropdown',
                source: [
                    { id:0, label: 'Gennaio' },
                    { id:1, label: 'Febbraio' },
                    { id:2, label: 'Marzo' },
                    { id:3, label: 'Aprile' },
                    { id:4, label: 'Maggio' },
                    { id:5, label: 'Giugno' },
                    { id:6, label: 'Luglio' },
                    { id:7, label: 'Agosto' },
                    { id:8, label: 'Settembre' },
                    { id:9, label: 'Ottobre' },
                    { id:10, label: 'Novembre' },
                    { id:11, label: 'Dicembre' },
                ],
                placeholder: 'Seleziona',
                settings: {
                  singleSelection: true,
                  closeDropDownOnSelection: true,
                  singleOutput:true,
                  idField: 'id',
                  textField: 'label',
                },
                OnChange: 'Refresh',
                class: 'col-lg-2',
                visibleifProhibited: true
            },
            { nome: "Ex. Dipendenti", oggetti:["cancellati"], modificabile: true, inputType: 'checkbox', class: 'col-lg-1', OnChange: 'Refresh',},
        ]
    }
    var env = {
        headButtons: ['giornate', 'giornateMO', 'riepilogoF', 'allinea'],
        Cruds: [OBJ],
        Menu: [
            {
                path: "/listautenti/presenze/manager/K",
                title: "Registro presenze",
                icon: "fas fa-book",
                capacita: ['gestione-persone']
            }
        ],
        TaskAddon: {
            DynamicFields:[Badge()],
            dataClickEvent: function(data, api) {

                if (confirm("Vuoi registrare il giorno festivo per tutti?")) {
                    return api.ClassicPost('/anagrafica/persone/badge/festivita', { data: data.substring(0,10) })
                }
                return EMPTY;
            }
        }
    };
    return env;
}
